import {
  RESET_PASSWORD_LOADING,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "redux/types";

import { Dispatch } from "redux";

import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { resetPasswordUrl } from "api/apiUrls";

export const resetPasswordActions =
  (data: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: RESET_PASSWORD_LOADING, payload: true });
      const response = await createNewItemService(
        `${resetPasswordUrl}`,
        data,
        "",
        "json"
      );

      if (response.status === 200) {
        notification.success({
          message: "Password has been reset successfully",
        });
        callback();
      } else {
        notification.error({
          message: "Something went wrong",
        });
      }

      dispatch({ type: RESET_PASSWORD_SUCCESS, payload: response.data });
    } catch (err: any) {
      notification.error({
        message: `${err.message}`,
      });
      dispatch({ type: RESET_PASSWORD_FAILURE, payload: err });
    } finally {
      dispatch({ type: RESET_PASSWORD_LOADING, payload: false });
    }
  };
